import React, { FC, Fragment, useEffect, useState } from "react";
import { Button, InputField } from "../../forms";
import { ModalPropsDTO } from "../../../typings/generic";
import { useStateGetter } from "../../../hooks/statehooks/UseStateGettersHook";
import { useForm } from "react-hook-form";
import { addressRegex, emailReg, numReg, textReg } from "../../../utils/regex";
import { ListPicker } from "../../generic/ListPicker";
import { usePickerhook } from "../../../hooks/usePickerhook";
import { onAddDept } from "../../../services/department";
import { toast } from "react-toastify";
import { useStateSetter } from "../../../hooks/statehooks/UseStateSettersHook";
import { useOrganizationHook } from "../../../hooks/useOrganizationHook";
import Datepicker from "../../generic/Datepicker";
import useDepartmentHook from "../../../hooks/useDepartmentHook";
import useEmployeeHook from "../../../hooks/useEmployeeHook";
import { contractTypes } from "../../../constant/data";
import { onAddAppraisalTemp } from "../../../services/appraisal";
import usePositionHook from "../../../hooks/usePositionHook";
import useAppraisalTempHook from "../../../hooks/useAppraisalTempHook";
import { FaCalendar, FaPlus } from "react-icons/fa";
import { CiCirclePlus, CiEdit } from "react-icons/ci";
import { MdDelete, MdMore } from "react-icons/md";
import { IoMdEye, IoMdMore } from "react-icons/io";
import { AiOutlineFileText } from "react-icons/ai";
import { Menu, Transition } from "@headlessui/react";
import { FiFileMinus } from "react-icons/fi";
import PreviewAppraisalTemplateModal from "../Appraisal/PreviewAppraisalTemplateModal";
import AppraisalTemplateItem from "../Appraisal/AppraisalTemplateItem";
import MiniAppraisalTemplateItem from "../Appraisal/MiniAppraisalTemplateItem";
import useGoalsHook from "../../../hooks/useGoalsHook";

export default (props: any) => {
  var { control, handleSubmit, watch } = useForm();
  const rolepickhook = usePickerhook();
  const departmentPickhook = usePickerhook();
  const positionPickhook = usePickerhook();
  const approvalpickhook = usePickerhook();

  const approvalsTemp = [
    { name: "No approval", code: "noapproal" },
    { name: "Line manager", code: "linemanager" },
    { name: "HR manager", code: "hrmanager" },
    { name: "HR manager & Line manager", code: "hrmanager&linemanager" },
  ];
  const { selectedOrgDepts } = useDepartmentHook();
  const { allorgPositions } = usePositionHook();
  const { setLoading } = useStateSetter();
  const [error, seterror] = useState("");
  const [condition, setcondition] = useState(false);
  const watchedFields = watch(["name", "description"]);
  const [showaddgoals, setshowaddgoals] = useState(false);
  const [goals, setgoals] = useState<any[]>([]);
  const { SelectedOrg, config } = useStateGetter();
  const [iseditgoal, setiseditgoal] = useState(false);
  const [editgoal, seteditgoal] = useState([]);
  const { orgAppTemplates, getOrgTemplates } = useAppraisalTempHook();
  const { AddGoal } = useGoalsHook();
  const { AddAppTemp } = useAppraisalTempHook();
  const areFieldsFilled = watchedFields.every(
    (field) =>
      field !== "" &&
      field !== undefined &&
      (departmentPickhook.pickedRole || positionPickhook.pickedRole) &&
      approvalpickhook.pickedRole
  );
  interface postdataDTO {
    name: string;
    deptID?: number;
    positionID?: number;
    // role: string;
    approval: string;
    desc: string;
    target?: string;
    organizationID: number;
  }
  const onSubmit = async (data: any) => {
    var postdata: postdataDTO;
    var pre_def: any;

    switch (props.target) {
      case "pos":
        postdata = {
          name: data.name,
          positionID: positionPickhook.pickedRole.code,
          //role: rolepickhook.pickedRole.name,
          approval: approvalpickhook.pickedRole.name,
          desc: data.description,
          target: "position",
          organizationID: SelectedOrg.id,
        };

        pre_def = {
          target: "position",
          positionID: positionPickhook.pickedRole.code,
          progress: "0",
        };
        break;

      case "dept":
        postdata = {
          name: data.name,
          deptID: departmentPickhook.pickedRole.code,
          //  role: rolepickhook.pickedRole.name,
          target: "dept",
          approval: approvalpickhook.pickedRole.name,
          desc: data.description,
          organizationID: SelectedOrg.id,
        };
        pre_def = {
          target: "dept",
          deptID: departmentPickhook.pickedRole.code,
          progress: "0",
        };
        break;

      default:
        postdata = {
          name: data.name,
          //role: rolepickhook.pickedRole.name,
          approval: approvalpickhook.pickedRole.name,
          desc: data.description,
          target: "organization",
          organizationID: SelectedOrg.id,
        };

        pre_def = { target: "organization", progress: "0" };
        break;
    }

    setLoading(true);
    try {
      var response = await AddAppTemp(postdata);
      toast.success(response.message);
      //Add goals to appraisal
      await Promise.all(
        goals.map(async (goal: any) => {
          await AddGoal({
            ...goal,
            ...pre_def,
            templateID: response.data.id,
            organizationID: SelectedOrg.id,
          });
        })
      );
    } catch (e: unknown) {
      console.log(e);
    } finally {
      setLoading(false);
      props.refresh();
      props.show(false);
    }
  };

  return (
    <>
      <div className="ModalContainer shadow relative">
        {showaddgoals && (
          <AddGoalmodal
            isedit={iseditgoal}
            setiseditgoal={setiseditgoal}
            item={editgoal}
            setgoals={setgoals}
            show={setshowaddgoals}
          />
        )}
        <div className=" flex flex-col z-10   rounded-[8px] bg-white w-[40vw] p-4 ">
          <p className="font-semibold self-start text-sm ">Add Template</p>
          <div className=" grid grid-cols-2 gap-2">
            <InputField
              name="name"
              title="Name"
              placeholder={"Enter Template Name"}
              control={control}
              rules={{
                required: "name is required",
                pattern: {
                  value: textReg,
                  message: "Invalid name",
                },
              }}
            />

            {props.target == "dept" && (
              <ListPicker
                fullwidth
                hook={departmentPickhook}
                title="Department"
                list={selectedOrgDepts.map((i) => {
                  return { name: i.deptName, code: i.id };
                })}
              />
            )}

            {props.target == "pos" && (
              <ListPicker
                fullwidth
                hook={positionPickhook}
                title="Position"
                list={allorgPositions.map((i) => {
                  return { name: i.positionTitle, code: i.id };
                })}
              />
            )}

            {/* <ListPicker
              fullwidth
              hook={rolepickhook}
              title="Role"
              list={[
                { name: "Employee", code: "employee" },
                { name: "Line manager", code: "line manager" },
              ]}
            /> */}

            <ListPicker
              fullwidth
              hook={approvalpickhook}
              title="Approval"
              list={approvalsTemp}
            />

            <InputField
              name="description"
              title="Template description"
              placeholder={"Enter description"}
              isTextArea
              control={control}
              rules={{
                required: "description is required",
                pattern: {
                  value: textReg,
                  message: "Invalid description",
                },
              }}
            />
          </div>

          <div>
            <div className="flex w-full justify-between items-center">
              <p className="  font-bold mt-2 text-sm "> Goals</p>
              <p
                onClick={() => setshowaddgoals(true)}
                className="text-sm  mt-2 text-primary font-semibold cursor-pointer "
              >
                <CiCirclePlus className="inline  " /> Add Goal
              </p>
            </div>

            <div className="grid grid-cols-2 gap-4">
              {goals.map((ik: any, key: number) => (
                <GoalItem
                  seteditgoal={seteditgoal}
                  key={key}
                  setshowaddgoals={setshowaddgoals}
                  setiseditgoal={setiseditgoal}
                  setgoals={setgoals}
                  item={ik}
                />
              ))}
            </div>
          </div>

          <div>
            <p className="text-sm font-bold mt-2 ">Feedback form</p>

            <div className="grid grid-cols-2 gap-2 ">
              <MiniAppraisalTemplateItem
                refresh={getOrgTemplates}
                item={{
                  ...orgAppTemplates.filter((kl: any) =>
                    kl.name
                      .toLowerCase()
                      .includes("Employee Feedback".toLowerCase())
                  )[0],
                  name: "Self Assessment Form",
                }}
              />
              <MiniAppraisalTemplateItem
                refresh={getOrgTemplates}
                item={{
                  ...orgAppTemplates.filter((kl: any) =>
                    kl.name
                      .toLowerCase()
                      .includes("Manager Feedback".toLowerCase())
                  )[0],
                  name: "Manager Feedback Form",
                }}
              />
            </div>
          </div>

          <div className=" flex justify-center items-center w-full gap-6">
            <Button
              outlined
              text="Cancel"
              onBtnClick={() => {
                props.show(false);
              }}
            />

            <Button
              disabled={!areFieldsFilled}
              text="Add Template"
              onBtnClick={handleSubmit(onSubmit)}
            />
          </div>
        </div>
      </div>
    </>
  );
};
const GoalItem = ({
  item,
  setshowaddgoals,
  setiseditgoal,
  seteditgoal,
  setgoals,
}) => (
  <div className="border border-1 flex justify-between text-textbg border-gray-200 py-1 px-2 rounded-[8px] bg-white">
    <div>
      {" "}
      <p className="font-semibold text-sm ">{item.title}</p>
      <p className="text-xs font-light">{item.desc}</p>
      <p className="text-xs font-semiboldx">
        <FaCalendar className="inline mr-1" />
        {item.date}
      </p>
    </div>
    <Menu as="div" className={`relative my-2 `}>
      <Menu.Button className="   w-full       ">
        <IoMdMore />
      </Menu.Button>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items
          onClick={() => {}}
          className="origin-top-left z-10 absolute left-0 mt-2 rounded-sm shadow-md p-1 bg-white w-full  max-h-[200px] min-w-[180px]   overflow-x-hidden overflow-y-scroll ring-1 ring-black ring-opacity-5 focus:outline-none"
        >
          <Menu.Item>
            <p
              onClick={() => {
                setiseditgoal(true);
                seteditgoal(item);
                setshowaddgoals(true);
              }}
              className=" text-xs font-light w-full text-black p-3 m-2 cursor-pointer truncate hover:bg-customGray "
            >
              <CiEdit className="inline" /> Edit
            </p>
          </Menu.Item>
          <Menu.Item>
            <p
              onClick={() => {
                setgoals((prev: any) => prev.filter((lk: any) => item != lk));
              }}
              className=" text-xs font-light w-full text-black p-3 m-2 cursor-pointer truncate hover:bg-customGray "
            >
              <MdDelete className="inline" /> Delete
            </p>
          </Menu.Item>
        </Menu.Items>
      </Transition>
    </Menu>
  </div>
);

const AddGoalmodal = ({ isedit, setiseditgoal, setgoals, item, show }) => {
  const AddGoal = (data: any) => {
    if (isedit) {
      setgoals((prev: any) =>
        prev.filter((kl: any) => kl != item).concat([{ ...data }])
      );
      setiseditgoal(false);
    } else {
      setgoals((prev: any) => prev.concat([{ ...data }]));
    }

    show(false);
  };

  var { control, handleSubmit, watch, setValue } = useForm();
  const watchedFields = watch(["title", "desc", "date"]);
  const areFieldsFilled = watchedFields.every(
    (field) => field !== "" && field !== undefined
  );
  useEffect(() => {
    if (isedit) {
      setValue("title", item.title);
      setValue("desc", item.desc);
      setValue("date", item.date);
    }
  }, []);
  return (
    <div className="ModalContainer shadow">
      <div className=" flex flex-col    rounded-[8px] bg-white w-[30vw] p-4 z-20 absolute">
        <p className="font-semibold self-start text-sm ">Add Goal</p>
        <InputField
          name="title"
          title="Goal title"
          placeholder={"Enter goal title"}
          control={control}
          rules={{
            required: "title is required",
            pattern: {
              value: textReg,
              message: "Invalid title",
            },
          }}
        />

        <InputField
          name="desc"
          title="Goal description"
          placeholder={"Enter description"}
          isTextArea
          control={control}
          rules={{
            required: "description is required",
            pattern: {
              value: textReg,
              message: "Invalid description",
            },
          }}
        />

        <InputField
          name="date"
          title="Goal dealine"
          placeholder={"Enter deadline"}
          type={"date"}
          control={control}
          rules={{
            required: "deadline is required",
            pattern: {
              value: addressRegex,
              message: "Invalid deadline",
            },
          }}
        />

        <div className=" flex justify-center items-center w-full gap-6">
          <Button
            outlined
            text="Cancel"
            onBtnClick={() => {
              show(false);
            }}
          />

          <Button
            disabled={!areFieldsFilled}
            text={!isedit ? "Add Goal" : "Save"}
            onBtnClick={handleSubmit(AddGoal)}
          />
        </div>
      </div>
    </div>
  );
};
